module.exports = "<p>\n  manual-user works!\n</p>\n"